import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logger } from 'projects/common/src/app/classes';
import { CacheService } from 'projects/common/src/app/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommunicationService } from 'src/app/services/communication';

import { IOutputFilter } from '../../core/interfaces/output-filter';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportTransitService extends Logger {
  private baseUrl: string;

  constructor(
    private cacheService: CacheService,
    private http: HttpClient,
    private communicationService: CommunicationService,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * Get data Report Transit
   *
   * @param selectedFilters
   */
  public getTransitReportData(selectedFilters: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilters);

    const url = `${this.baseUrl}/Report/GetTransitReport`;
    return this.communicationService
      .get(url, params)
      .pipe(catchError((err) => this.handleError(err)))
      .toPromise();
  }

  /**
   * Get transit excel report from 'getTransitReportDocument' endpoint
   */
  public GetTransitReportExcel(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetTransitReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: String(selectedFilters.shiftId),
      machineTypeList: selectedFilters.machineTypeId,
      machineList: selectedFilters.machineId,
      companyId,
    };
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    this.error(err);
    return throwError(err);
  }
}
